import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {ListResponseModel} from '../../../shared/models/ListResponseModel'
import {toast} from 'react-toastify'
import {RootState} from '../../../../setup/redux/Store'
import {BranchModel} from '../models/BranchModel'
import {BranchListFilterModel} from '../models/BranchListFilterModel'
import {CreateBranchModel} from '../models/CreateBranchModel'
import {UserBranchModel} from '../models/UserBranchModel'
import {CreateUserBranchModel} from '../models/CreateUserBranchModel'
import {getCurrentIntl} from '../../../shared/utils/i18nUtils'

export interface ISchedulerState {
  list: BranchModel[]
  filter: BranchListFilterModel
  loading: boolean
  transactionLoading: boolean
  currentUserSettingSchedule: BranchModel | undefined
  showAddBranchModal: boolean
  listBranchUsers: UserBranchModel[]
  listBranchUsersFilter: BranchListFilterModel
  showAddBranchUserModal: boolean
}

const initialState: ISchedulerState = {
  list: [],
  filter: {
    page: 1,
    take: Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE),
    itemCount: 0,
    pageCount: 1,
  } as BranchListFilterModel,
  loading: false,
  transactionLoading: false,
  currentUserSettingSchedule: undefined,
  showAddBranchModal: false,
  listBranchUsers: [],
  listBranchUsersFilter: {
    page: 1,
    take: Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE),
    itemCount: 0,
    pageCount: 1,
  } as BranchListFilterModel,
  showAddBranchUserModal: false,
}

export const BranchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    getAll: (state) => {
      state.loading = true
    },
    getBranchUsers: (state) => {
      state.loading = true
    },
    setShowAddBranchModal: (state, action: PayloadAction<boolean>) => {
      state.showAddBranchModal = action.payload
    },
    setBranchUsersList: (state, action: PayloadAction<ListResponseModel<UserBranchModel>>) => {
      state.loading = false
      state.listBranchUsers = action.payload.data
      state.listBranchUsersFilter = {...state.listBranchUsersFilter, ...action.payload.meta}
    },
    branchUsersFilterDataChange: (state, action: PayloadAction<BranchListFilterModel>) => {
      state.loading = true
      state.listBranchUsersFilter = action.payload
    },
    setList: (state, action: PayloadAction<ListResponseModel<BranchModel>>) => {
      state.loading = false
      state.list = action.payload.data
      state.filter = {...state.filter, ...action.payload.meta}
    },
    filterDataChange: (state, action: PayloadAction<BranchListFilterModel>) => {
      state.loading = true
      state.filter = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.transactionLoading = false
      const currentIntl = getCurrentIntl()
      toast.error(currentIntl.formatMessage({id: 'SERVER.' + action.payload}))
    },
    setSuccess: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.transactionLoading = false
      toast.success(action.payload)
    },

    create: (state, action: PayloadAction<CreateBranchModel>) => {
      state.transactionLoading = true
    },
    update: (state, action: PayloadAction<BranchModel>) => {
      state.transactionLoading = true
    },

    updateBranchStatus: (state, action: PayloadAction<{id: number; status: string; targetPersonInChargeId?: number; targetBranchId?: number}>) => {
      state.transactionLoading = true
    },
    updateUserBranchStatus: (state, action: PayloadAction<{ userIds: number[]; status: string }>) => {
      state.transactionLoading = true
    },
    setShowAddBranchUserModal: (state, action: PayloadAction<boolean>) => {
      state.showAddBranchUserModal = action.payload
    },
    createBranchUser: (state, action: PayloadAction<CreateUserBranchModel>) => {
      state.transactionLoading = true
    },
  },
})
export const {
  create,
  update,
  setSuccess,
  getAll,
  setList,
  filterDataChange,
  setError,
  updateBranchStatus,
  setShowAddBranchModal,
  setBranchUsersList,
  branchUsersFilterDataChange,
  setShowAddBranchUserModal,
  updateUserBranchStatus,
  getBranchUsers,
  createBranchUser,
} = BranchSlice.actions
export const selectBranchLoading = (state: RootState) => state.branch.loading
export const selectBranchList = (state: RootState) => state.branch.list
export const selectBranchFilter = (state: RootState) => state.branch.filter
export const selectTransactionLoading = (state: RootState) => state.branch.transactionLoading
export const selectShowAddBranchModal = (state: RootState) => state.branch.showAddBranchModal
export const selectBranchUsersList = (state: RootState) => state.branch.listBranchUsers
export const selectBranchUsersFilter = (state: RootState) => state.branch.listBranchUsersFilter
export const selectShowAddBranchUserModal = (state: RootState) =>
  state.branch.showAddBranchUserModal

export default BranchSlice.reducer
